import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold uppercase tracking-wider transition-all duration-300 overflow-hidden group';
  const variants = {
    primary: 'bg-intense-red text-white hover:bg-red-700 shadow-[0_0_20px_rgba(255,0,0,0.4)] hover:shadow-[0_0_30px_rgba(255,0,0,0.6)] border border-red-500/50',
    secondary: 'bg-electric-blue text-white hover:bg-blue-600 shadow-[0_0_20px_rgba(0,170,255,0.4)] hover:shadow-[0_0_30px_rgba(0,170,255,0.6)] border border-blue-400/50',
    outline: 'bg-transparent text-white border-2 border-electric-blue hover:bg-electric-blue/10 shadow-[0_0_15px_rgba(0,170,255,0.2)]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-8 py-4 text-base',
    lg: 'px-10 py-5 text-lg md:text-xl',
    xl: 'px-12 py-6 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className} rounded-sm`} {...props} data-id="element-148">
      <span className="relative z-10 flex items-center gap-2" data-id="element-149">{children}</span>
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-150" />
    </motion.button>;
}